import React from 'react'
import { Trans } from 'react-i18next'

import { BarcodeType } from '@makyoapp/makyo-common'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { useCreateColumnContext } from '@/context/CreateColumnContext'

import { ColumnDd } from './ColumnDd'
import { Fld, Lbl } from './shared'

/**
 * handle barcode type selection
 */
function FieldType() {
  const { id, value, setValue } = useCreateColumnContext()
  return (
    <Fld>
      <Lbl>
        <Trans>Type</Trans>
      </Lbl>
      <SelectDropdown
        id={`${id}-barcode-type`}
        menuDefaultSize={false}
        menuClassName={'max-h-[220px] overflow-y-auto'}
        menuContainerClassName='mk-ag-sdd'
        menuZIndex='z-305'
        portalMenu
        value={value.barcodeOptions.barcodeType}
        options={Object.values(BarcodeType)}
        onChange={(opt) => {
          setValue({
            barcodeOptions: {
              ...value.barcodeOptions,
              barcodeType: opt,
            },
          })
        }}
      />
    </Fld>
  )
}

/**
 * handle barcode source column
 */
function FieldColumn() {
  const { id, value, setValue } = useCreateColumnContext()
  return (
    <Fld>
      <Lbl>
        <Trans>Column</Trans>
      </Lbl>
      <ColumnDd
        id={`${id}-barcode-column`}
        onChange={(opt) => {
          setValue({
            barcodeOptions: {
              ...value.barcodeOptions,
              barcodeColumn: opt.id,
            },
          })
        }}
        selected={value.barcodeOptions.barcodeColumn}
      />
    </Fld>
  )
}

/**
 * fields for column type Barcode
 */
export default function FieldBarcode() {
  return (
    <>
      <FieldType />
      <FieldColumn />
    </>
  )
}
